import React, { useState } from "react";
import PropTypes from "prop-types";

const UpgradeBannerTop = ({ className }) => {
  const [visible, setVisible] = useState(true);

  const handleDismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <a href="https://spiking.com/system" className="block cursor-pointer">
      <div
        className={`flex w-full items-center justify-center gap-4 bg-[linear-gradient(90deg,#0061F9_0%,#0D8BFF_100%)] px-4 py-3 text-white ${
          className || ""
        }`}
      >
        Stop guessing. Start trading with an edge. Find your stage.
        <button
          type="button"
          onClick={handleDismiss}
          className="flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full border border-white p-2 font-bold text-white text-xs hover:opacity-80"
        >
          X
        </button>
      </div>
    </a>
  );
};

UpgradeBannerTop.propTypes = {
  className: PropTypes.string,
};

export default UpgradeBannerTop;
